import { Vue, Component, Prop } from 'vue-property-decorator';
import type { CreateElement, VNode } from 'vue';
import IPSDialog from '../picker/dialog';
import DialogFactory from '../picker/dialogFactory';
import { IPSService } from '@/services/ipsServices';
import { downloadIamge } from '@/util';

@DialogFactory
@Component({
  mixins: [],
  components: {},
})
export default class ImgPreview extends IPSDialog {
  img = '';

  title = '图片预览';

  width = '600px';

  confirm = false;

  isShowDownload = false

  exportQrcode(){
    downloadIamge(this.img, 'distributionQrcode')
  }

  renderContent(h: CreateElement): VNode {
    return (
      <div class="r-mt-30 r-ml-90 hei-225">
        <img src={this.img} alt="" style="width:80%;" />
        {this.isShowDownload && (<p class="r-mt-14 font-center r-pr-90"><span class="scopeSpan" onClick={()=>this.exportQrcode()}>下载</span></p>)}
      </div>
    );
  }
}
